module.exports = __webpack_public_path__ + "img/image-6.3bf92f77.jpeg";